import { db } from './firebase'
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
} from 'firebase/firestore'

const MAILING_LIST_COLLECTION = 'mailingList'

// הוספת אימייל לרשימת הדיוור עם הודעות Toast
export async function addEmailToMailingList(email) {
  if (!email) {
    return { success: false, message: 'כתובת אימייל לא תקינה' }
  }

  try {
    // בדיקה אם האימייל כבר קיים
    const q = query(
      collection(db, MAILING_LIST_COLLECTION),
      where('email', '==', email)
    )
    const querySnapshot = await getDocs(q)

    if (!querySnapshot.empty) {
      return { success: false, message: 'כתובת האימייל כבר רשומה' }
    }

    // הוספת האימייל למסד הנתונים
    await addDoc(collection(db, MAILING_LIST_COLLECTION), {
      email,
      addedAt: serverTimestamp(), // שימוש בזמן מהשרת
    })

    return { success: true, message: 'האימייל נוסף בהצלחה!' }
  } catch (error) {
    console.error('Error adding email to mailing list:', error)
    return { success: false, message: 'שגיאה בהוספת האימייל' }
  }
}
